import { render, staticRenderFns } from "./Wolf.vue?vue&type=template&id=3ab341c3&scoped=true&lang=pug&"
import script from "./Wolf.ts?vue&type=script&lang=ts&"
export * from "./Wolf.ts?vue&type=script&lang=ts&"
import style0 from "./Wolf.vue?vue&type=style&index=0&id=3ab341c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab341c3",
  null
  
)

export default component.exports